import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { readInitialPageData } from "@/lib/pageData";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const element = document.getElementById("root");
const initialData = readInitialPageData();
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App initialData={initialData} />
    </QueryClientProvider>
  </React.StrictMode>
);
if (initialData?.pathname === window.location.pathname && !window.location.search && element.hasChildNodes()) {
  ReactDOM.hydrateRoot(element, tree, { identifierPrefix: "mynavo-" });
} else {
  ReactDOM.createRoot(element).render(tree);
}
